export const getPropertiesFilterLocalStorageKey = (userUid: string) =>
  `properties-user:${userUid}`;
